import React, { Component } from "react";
import { getMenuItems } from "../services/MenuItems";
import { dispatchEventClickTag } from "../utils/Tags";
import "antd/dist/antd.less";

export class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstPartFooter: [],
      secondPartFooter: [],
      thirdPartFooter: []
    };
  }

  componentDidMount() {
    getMenuItems("footer").then(res =>
      res.map((m, index) =>
        this.setState({
          firstPartFooter: [
            ...this.state.firstPartFooter,
            <li key={index}>
              <a
                className="menu-footer-item-link"
                href={m.absolute}
                onClick={() =>
                  dispatchEventClickTag(m.title, "footer", "", "navigation")
                }
              >
                {m.title}
              </a>
            </li>
          ]
        })
      )
    );

    getMenuItems("menu-footer").then(res =>
      res.map((m, index) =>
        this.setState({
          secondPartFooter: [
            ...this.state.secondPartFooter,
            <li key={index} className="menu-footer-item">
              <a
                className="menu-footer-item-link"
                href={m.absolute}
                onClick={() =>
                  dispatchEventClickTag(m.title, "footer", "", "navigation")
                }
              >
                {m.title}
              </a>
            </li>
          ]
        })
      )
    );

    getMenuItems("menu-info").then(res =>
      res.map((m, index) =>
        this.setState({
          thirdPartFooter: [
            ...this.state.thirdPartFooter,
            <li key={index} style={{ padding: 20 }}>
              <a
                className="menu-footer-item-link"
                href={m.absolute}
                onClick={() =>
                  dispatchEventClickTag(m.title, "footer", "", "navigation")
                }
              >
                {m.title}
              </a>
            </li>
          ]
        })
      )
    );
  }

  render() {
    const { firstPartFooter, secondPartFooter, thirdPartFooter } = this.state;
    return (
      <div className="footer-bottom">
        <div className="menu-footer-container">
          <ul className="first-menu-footer-container">
            {firstPartFooter.map(m => m)}
          </ul>
          <ul className="second-menu-footer-container">
            {secondPartFooter.map(m => m)}
          </ul>
          <ul className="third-menu-footer-container">
            {thirdPartFooter.map(m => m)}
          </ul>
        </div>
      </div>
    );
  }
}
